import React, { useCallback, useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import useFetch from '../../hooks/useFetch';
// import MainLayout from '../../layouts/MainLayout';
import 'react-datepicker/dist/react-datepicker.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { useLocation } from 'react-router-dom';
import Loader from '../../components/utils/Loader';
import Tooltip from '../../components/utils/Tooltip';

const IAmMentoring = () => {
  const location = useLocation();
  const authState = useSelector(state => state.authReducer);
  const [userId, setUserId] = useState(authState.user._id);
  const [mentorCode, setmentorCode] = useState(authState.user.think5whyscode);
  const [mentoring, setMentoring] = useState([]);
  const [fetchData, { loading }] = useFetch();
  const [selectedMenteeId, setselectedMenteeId] = useState(null);

  const [showMenteeBooks, setShowMenteeBooks] = useState(null);
  const [showMenteeAssignments, setShowMenteeAssignments] = useState(null);
  const [showMenteePractices, setShowMenteePractices] = useState(null);
  const [showMenteeExams, setShowMenteeExams] = useState(null);
  const [showMenteeCertificates, setShowMenteeCertificates] = useState(null);

  const fetchUsers = useCallback((mentorType) => {
    const config = {
        url: "/mentors/iam",
        method: "post",
        headers: { Authorization: authState.token },
        data: { mentorCode: mentorCode }
    };
    // console.log("Getting my users",config);

    fetchData(config, { showSuccessToast: false })
        .then(response => {
            // console.log("Response:", response);
            if (response && Array.isArray(response.iamMentor)) {
                setMentoring(response.iamMentor);
            } else {
                console.error("Invalid response format: mentors not found in response");
            }
        })
        .catch(error => {
            console.error("Error fetching mentors:", error);
        });
  }, [authState.token, fetchData, mentorCode]);

  useEffect(() => {
      if (!authState.isLoggedIn) return;
      fetchUsers();
    }, [authState.isLoggedIn, fetchUsers]);

    const handleView = (userId) => {
      setselectedMenteeId(prevId => (prevId === userId ? null : userId));
    };

      const formatDateTime = (date) => {
      const options = {
          year: 'numeric', month: '2-digit', day: '2-digit',
          hour: '2-digit', minute: '2-digit', second: '2-digit',
          hour12: false
      };
      const jsDate = new Date(date);
      const day = jsDate.getDate().toString().padStart(2, '0');
      const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
      const year = jsDate.getFullYear();
      const hours = jsDate.getHours().toString().padStart(2, '0');
      const minutes = jsDate.getMinutes().toString().padStart(2, '0');
      const seconds = jsDate.getSeconds().toString().padStart(2, '0');
      return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  };

  const sortedMentoring = [...mentoring].sort((a, b) => b.userName - a.userName);

  const handleMenteeBooks = (userId) => {
    setShowMenteeBooks(true);
  };

  const handleMenteeAssignments = (userId) => {
    setShowMenteeAssignments(true);
  };

  const handleMenteePractices = (userId) => {
    setShowMenteePractices(true);
  };

  const handleMenteeExams = (userId) => {
    setShowMenteeExams(true);
  };

  const handleMenteeCertificates = (userId) => {
    setShowMenteeCertificates(true);
  };

  return (
    <>
      <div className="min-h-screen bg-black text-white [&_p]:text-white py-2">
        <div>
          <h2 className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>Learning - My Mentees</h2>
        </div>
        <div className="my-2 mx-auto max-w-[700px] py-4">
          <div className="border border-gray-300 p-4 mt-4">
            <div className="mt-2">
              <div className="mt-2">
                {mentoring && mentoring.length !== 0 && (
                  <div className="flex justify-between items-center border-b border-b-gray-300">
                    <div>
                      <h3 className='text-xl mt-1 mx-2 text-white'>{mentoring.length} Mentee Found!</h3>
                    </div>
                </div>
                )}
              </div>
            </div>
            {loading ? (
              <Loader />
            ) : (
              <div className='text-sm'>
                {mentoring && mentoring.length === 0 ? (
                  <div className='w-[600px] h-[300px] flex items-center justify-center gap-4 text-yellow-300'>
                    <div className="flex justify-between items-center">
                    <div>
                      <h3 className='text-xl mt-1 mx-2 text-orange-400'>No Mentee Record Found!</h3>
                    </div>
                </div>
                  </div>
                ) : (
                  sortedMentoring.map((mentee, index) => (
                    <div key={mentee._id} className='bg-white my-1 p-2 text-gray-600 rounded-md shadow-md'>
                      <div className='flex'>
                        <span className='font-medium'>#{index + 1}. {mentee.userName}</span>
                        <Tooltip text={"View details"} position={"top"}>
                          <span className='ml-auto mr-2 text-blue-500 cursor-pointer' onClick={() => handleView(mentee._id)}>
                            <i className="fa-solid fa-eye"></i>
                          </span>
                        </Tooltip>
                        <Tooltip text={"Books"} position={"top"}>
                            <span className='text-green-500 cursor-pointer mr-1' disabled={true} onClick={() => handleMenteeBooks(mentee.userId)}>
                              <i className="fa-solid fa-book"></i>
                            </span>
                          </Tooltip>
                          <Tooltip text={"Assignments"} position={"top"}>
                            <span className='text-blue-500 cursor-pointer mr-1' disabled={true} onClick={() => handleMenteeAssignments(mentee.userId)}>
                              <i className="fa-solid fa-tasks"></i>
                            </span>
                          </Tooltip>
                          <Tooltip text={"Practices"} position={"top"}>
                            <span className='text-blue-500 cursor-pointer mr-1' disabled={true} onClick={() => handleMenteePractices(mentee.userId)}>
                              <i className="fa-solid fa-star"></i>
                            </span>
                          </Tooltip>
                          <Tooltip text={"Exams"} position={"top"}>
                            <span className='text-blue-500 cursor-pointer mr-1' disabled={true} onClick={() => handleMenteeExams(mentee.userId)}>
                              <i className="fa-solid fa-square"></i>
                            </span>
                          </Tooltip>      
                          <Tooltip text={"Certificates"} position={"top"}>
                            <span className='text-blue-500 cursor-pointer mr-2' disabled={true} onClick={() => handleMenteeCertificates(mentee.userId)}>
                              <i className="fa-solid fa-certificate"></i>
                            </span>
                          </Tooltip>      
                      </div>
                      {selectedMenteeId === mentee._id && (
                        <div className='bg-gray-200 text-black'>
                          <p className='text-blue-500'>{mentee.userName}</p>
                          <p>{mentee.userEmail}</p>
                          <p><strong>I am mentoring as: </strong>{mentee.mentorType}</p>
                          <p><strong>Mentoring Since:</strong> {formatDateTime(mentee.dateCreated)}</p>
                          <p><strong>Remarks:</strong> {mentee.remarks}</p>   
                                   
                        </div>
                      )}
                    </div>
                  ))
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default IAmMentoring

